import Parvus from "parvus";

export default function imageLightbox() {
  function init() {
    const lightbox = new Parvus({});
  }

  init();
}
